import {
  PEOPLE_RECOGNIZABLE_CHOICES,
  PEOPLE_RECOGNIZABLE_LABEL,
  PEOPLE_RECOGNIZABLE_LEGEND,
  type PeopleRecognizableChoice,
} from './media-compliance-fields.js';

/**
 * The three-state "is there a recognisable person on this photo" control,
 * shared by the upload panel, the detail dialog and the bulk bar — the same
 * reason `media-compliance-fields.ts` exists: all three surfaces ask the
 * identical question, and the whole C2 fix rests on none of them quietly
 * drifting back to a two-state control. Kept in its own `.tsx` so the
 * converters file stays pure TypeScript.
 *
 * `fieldset`/`legend` (not a bare row of inputs): the legend is the group's
 * accessible name, so a screen reader announces what the three options are
 * an answer TO. `namePrefix` keeps the radio group distinct when two of
 * these are mounted at once (the gallery renders the upload panel above the
 * grid while a dialog is open).
 */
export function PeopleRecognizableRadioGroup({
  namePrefix,
  value,
  onChange,
}: {
  namePrefix: string;
  value: PeopleRecognizableChoice;
  onChange: (next: PeopleRecognizableChoice) => void;
}) {
  return (
    <fieldset className="space-y-1.5 sm:col-span-2">
      <legend className="text-body font-medium text-[var(--ink-700)]">
        {PEOPLE_RECOGNIZABLE_LEGEND}
      </legend>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5">
        {PEOPLE_RECOGNIZABLE_CHOICES.map((choice) => (
          <label
            key={choice}
            className="flex cursor-pointer items-center gap-2 text-body text-[var(--ink-700)]"
          >
            <input
              type="radio"
              name={`${namePrefix}-people-recognizable`}
              value={choice}
              checked={value === choice}
              onChange={() => onChange(choice)}
              className="h-4 w-4 cursor-pointer border-[var(--app-divider-2)]"
            />
            {PEOPLE_RECOGNIZABLE_LABEL[choice]}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
